import CardContent from "@mui/joy/CardContent";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";

const PALETTE = {
    sand: "#D9A95E",
    orchid: "#C88BC4",
    slate: "#8B9AA7",
    gold: "#F4C200",
    orange: "#E1542B",
};

const INK = "#15171C";

const BillboardCard = (data) => {
    const name = data.name;
    const value = data.value;
    const time = data.time;
    const color = PALETTE[data.color] || PALETTE.sand;

    return (
        <Card
            variant="plain"
            sx={{
                backgroundColor: color,
                width: '100%',
                minHeight: { xs: 150, md: 220 },
                borderRadius: '28px',
                p: { xs: 2.5, md: 3 },
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                overflow: 'hidden',
            }}
        >
            <Typography level='h3' sx={{ textAlign: 'left', color: INK, fontWeight: 500, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
                {name}
            </Typography>

            <CardContent sx={{ flexGrow: 0, mt: 'auto', minWidth: 0 }}>
                <Stack direction="column" spacing={0} sx={{ alignItems: 'flex-end', minWidth: 0 }}>
                    <Typography
                        sx={{ color: INK, fontWeight: 600, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.05, overflowWrap: 'anywhere', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                        {value}
                    </Typography>
                    {time !== null && (
                        <Typography level='body-sm' sx={{ color: INK, fontWeight: 700, textAlign: 'right', overflowWrap: 'anywhere', maxWidth: '100%' }}>
                            → Since {time} ago
                        </Typography>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
}

export default BillboardCard;
